// extracted by mini-css-extract-plugin
export default {"splashStyle":"CrmIntegration_splashStyle__Assjj"};